import { render, staticRenderFns } from "./TeremPlayerStatisticsScreen.vue?vue&type=template&id=567206e4&scoped=true&"
import script from "./TeremPlayerStatisticsScreen.vue?vue&type=script&lang=js&"
export * from "./TeremPlayerStatisticsScreen.vue?vue&type=script&lang=js&"
import style0 from "./TeremPlayerStatisticsScreen.vue?vue&type=style&index=0&id=567206e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567206e4",
  null
  
)

export default component.exports